var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-title__wrapper"},[_c('div',{staticClass:"wp-title mb-4"},[_c('div',{staticClass:"wp-title__line"}),_c('h5',{staticClass:"wp-title__title"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }